import { render, staticRenderFns } from "./Sentence.vue?vue&type=template&id=3606d7d2&"
import script from "./Sentence.vue?vue&type=script&lang=js&"
export * from "./Sentence.vue?vue&type=script&lang=js&"
import style0 from "./Sentence.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports